import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './textarea.module.scss';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...restProps }, ref) => (
    <textarea
      className={joinCss(css.root, className)}
      ref={ref}
      {...restProps}
    />
  )
);

Textarea.displayName = 'Textarea';
